'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['', 'M48 160C48 98.1 98.1 48 160 48S272 98.1 272 160c0 38.7-20.1 76.3-56 97l-68 39.3-12 6.9 0 80.8 48 0 0-53.1 56-32.3c51.3-29.6 79.9-83.4 80-138.5l0 0C320 71.6 248.4 0 160 0S0 71.6 0 160l0 32 48 0 0-32zM188 504l0-56-56 0 0 56 56 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;